import { Preis } from 'fobclient/lib/entity'
import Person from './Person'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Preis')

export default {
  label: 'Preis',
  route: 'preis',
  className: 'preis',
  class: Preis,
  fields: [
    Fields.organisationseinheit,
    Fields.String('namePreis'),
    {
      ...Fields.PrefetchedSingleReference(
        'preisBezeichnung',
        'preisBezeichnung',
        'folder-open',
        'beschreibung',
        true
      ),
      orderBy: 'name',
      reorder: [
        1, 3, 29, 30, 31,
        32, 2, 33, 4, 23,
        6, 10, 11, 12, 14,
        15, 16, 17, 34, 35,
        36, 37, 18, 22, 28,
        24, 21, 19, 9, 20,
        27, 26, 25, 7, 5,
        13],
    },
    Fields.String('vergebenDurch'),
    {
      ...Fields.SingleReferenceByMultiValueSearchRep(
        'preisTraeger',
        'user',
        Person,
        false
      )
    },
    {
      label: 'Preis.form.hatPreisgeld',
      field: 'hatPreisgeld',
      type: 'select',
      translatable: true,
      values: [
        {
          value: true,
          label: 'Preis.hatPreisgeld.TRUE'
        },
        {
          value: false,
          label: 'Preis.hatPreisgeld.FALSE'
        },
        {
          value: null,
          label: ''
        }
      ]
    },
    Fields.Number('verleihungsJahr')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Preis.js